import { ref } from "vue";
import { Channel } from "../services/channel";

export function createDistrictsChannel(onReceived, onConnected) {
  var channel = new DistrictsChannel(onReceived, onConnected);
  channel.connect();
  return channel;
}

class DistrictsChannel extends Channel {
  constructor(onReceived, onConnected) {
    super("Geo::De::By::DistrictsChannel");
    this.onReceived = onReceived;
    this.onConnected = onConnected;
    this.latestUuid = null
  }

  connected() {
    if (this.onConnected) {
      this.onConnected();
    }
  }

  received(data) {
    if (this.onReceived && data.uuid === this.latestUuid) {
      this.onReceived(data);
    }
  }

  focus(district_id) {
    var uuid = crypto.randomUUID();
    var options = { uuid: uuid };
    if (district_id) {
      options.id = district_id;
    }
    this.latestUuid = uuid;
    this.perform("focus", options);
  }
}
